import { AppState } from "../../../redux-configuration/AppState";

export const editProductLoadingSelector = (appState: AppState): boolean => appState.ecommerce.editProduct.loading
export const editProductErrorSelector = (appState: AppState): string | undefined => appState.ecommerce.editProduct.error
export const editProductSuccessSelector = (appState: AppState): boolean | undefined => appState.ecommerce.editProduct.success
